import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

const config: AxiosRequestConfig = {
  baseURL: 'https://nominatim.openstreetmap.org',
};

const api: AxiosInstance = axios.create(config);

export default api;
